'use client';

import { createContext, useContext } from 'react';
import { CarouselApi } from './use-carousel';

export const CarouselContext = createContext<CarouselApi | null>(null);

export function useCarouselContext(): CarouselApi {
  const ctx = useContext(CarouselContext);
  if (!ctx) {
    throw new Error('Carousel.* components must be rendered inside <Carousel>.');
  }
  return ctx;
}
